export default "__VITE_ASSET__gCGfNB_W__"